import React, { FunctionComponent } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { AddCircle, PlaylistAddCheck } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { AlternativeType } from "../../Products/TenantProductEditor";
import useStyles from "./styles";

export interface AlternativeProps {
  alternative: AlternativeType;
  onChange: (alternative: AlternativeType) => void;
  onDelete: (name: string) => void;
}

export const Alternative: FunctionComponent<AlternativeProps> = ({
  alternative,
  onChange,
  onDelete
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleChange = (e: any, index: number) => {
    alternative.values[index] = e.target.value;

    onChange(alternative);
  };

  return (
    <>
      <Card variant={"outlined"} key={alternative.name}>
        <CardHeader
          style={{ padding: "4px 8px 0px 8px" }}
          avatar={
            <Avatar
              style={{
                width: 24,
                height: 24,
                backgroundColor: theme.palette.primary.main
              }}
              aria-label="recipe"
            >
              <PlaylistAddCheck style={{ width: 16, height: 16 }} />
            </Avatar>
          }
          title={alternative.name}
          action={
            <IconButton
              aria-label="settings"
              onClick={() => onDelete(alternative.name)}
            >
              <DeleteIcon />
            </IconButton>
          }
        />
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: mobile ? "column" : "row"
            }}
          >
            {alternative.values.map((value, i: number) => (
              <>
                <div style={{ display: "flex", width: "100%" }}>
                  <TextField
                    style={{ width: "100%" }}
                    className={classes.field}
                    name={`${alternative.name}_${i}`}
                    label={alternative.name}
                    type={"string"}
                    value={value ?? ""}
                    onChange={(event: any) => handleChange(event, i)}
                  />
                  {alternative.values.length - 1 !== i ? (
                    <IconButton
                      onClick={() => {
                        const values = alternative.values.filter(
                          (_, j) => j !== i
                        );
                        onChange({ ...alternative, values: values });
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  ) : (
                    <>
                      {alternative.values.length > 1 &&
                        alternative.values[alternative.values.length - 1]
                          .length > 0 && (
                          <IconButton
                            onClick={() => {
                              const values = alternative.values.filter(
                                (_, j) => j !== i
                              );
                              onChange({ ...alternative, values: values });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      <IconButton
                        style={{
                          color: !alternative.values[
                            alternative.values.length - 1
                          ].length
                            ? theme.palette.grey[500]
                            : "rgb(31, 132, 52)"
                        }}
                        disabled={
                          !alternative.values[alternative.values.length - 1]
                            .length
                        }
                        onClick={() => {
                          if (!value) value = "";
                          alternative.values = [...alternative.values, ""];
                          onChange(alternative);
                        }}
                      >
                        <AddCircle />
                      </IconButton>
                    </>
                  )}
                </div>
              </>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
};
